export const CATEGORY_ALL_SLUG = '/';

export function getPath(basePath: string, slug: string): string {
    if (slug !== CATEGORY_ALL_SLUG) {
        return basePath + slug + '/';
    } else {
        return basePath;
    }
}

export function getCategoryLinkID(slug: string, location: string): string {
    if (slug !== CATEGORY_ALL_SLUG) {
        return `${location}-${slug}`;
    } else {
        return `${location}-all`;
    }
}

export function getCanoncialUrl(slug: string): string {
    return slug === CATEGORY_ALL_SLUG ? '/presentation-template/' : `/presentation-template/${ slug }/`;
}



// WEBPACK FOOTER //
// ./assets/js/components/TemplateUtils.tsx